/* eslint-disable no-multi-str */
import { useState, useEffect } from "react";
import { Modal, ModalDialog, Typography, Button, Box, Chip } from "@mui/joy";
import { UpdateItem } from "../../Interfaces/UpdateItem";
import { faBars } from "@fortawesome/free-solid-svg-icons";

import Slider from "react-slick";
// @ts-ignore
import "slick-carousel/slick/slick.css";
// @ts-ignore
import "slick-carousel/slick/slick-theme.css";

const WHATS_NEW_VERSION = "6.0.2"

const updates: UpdateItem[] = [
    {
        image: "🤖",
        title: "Wingman, now in your workflow",
        subtitle: "Bring Appinion's review intelligence directly into your AI workflows with our new MCP integration. \
                Ask questions, explore feedback and uncover insights without leaving your tools.",
        icon: faBars,
        color: "#3b82f6"
    },
    {
        image: "👉",
        title: "Share reviews, instantly",
        subtitle: "Found a review worth sharing? You can now share individual reviews with your team or stakeholders in just a few clicks.\
                Make feedback easier to discuss and act on.",
        icon: faBars,
        color: "#3b82f6"
    },
    {
        image: "✉️",
        title: "Daily review notifications",
        subtitle: "Stay on top of what your users are saying, every day. Get a daily digest of your latest reviews and keep your team \
                informed without having to constantly check your apps.",
        icon: faBars,
        color: "#3b82f6"
    },
    {
        image: "👀",
        title: "Benchmark your performance",
        subtitle: "See how your app stacks up against the competition. Benchmark your ratings and review performance to understand \
                where you stand and where there's room to improve.",
        icon: faBars,
        color: "#3b82f6"
    }

]

export default function WhatsNewModal() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const lastVersion = localStorage.getItem("lastVersion");

        if (lastVersion !== WHATS_NEW_VERSION) {
            setOpen(true);
            localStorage.setItem("lastVersion", WHATS_NEW_VERSION);
        }
    }, []);

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>

            <ModalDialog
                maxWidth={600}
                sx={{
                    borderRadius: 12,
                    boxShadow: 'lg',
                    border: '1px solid',
                    borderColor: 'neutral.200',
                    p: 0,
                    overflow: 'hidden',
                }}>

                {/* Header */}
                <Box sx={{
                    p: 3,
                    textAlign: 'center'
                }}>
                    <Chip
                        variant="soft"
                        color="primary"
                        size="sm"
                        sx={{ fontWeight: 500, borderRadius: 4, px: 1.5, py: 0.5, border: '1px solid', borderColor: 'primary.200' }}
                    >
                        Version {WHATS_NEW_VERSION}
                    </Chip>
                </Box>

                {/* Content area */}
                <Box sx={{ pb: 3, px: 2 }}>
                    <Box
                        sx={{
                            '& .custom-dots': {
                                '& li button:before': {
                                    color: 'rgba(0, 0, 0, 0.3)',
                                    fontSize: 10,
                                },
                                '& li.slick-active button:before': {
                                    color: '#1976d2',
                                },
                            },
                        }}
                    >
                        <Slider
                            dots={true}
                            infinite={updates.length > 1}
                            speed={300}
                            slidesToShow={1}
                            slidesToScroll={1}
                            adaptiveHeight={false}
                            arrows={false}
                            dotsClass="slick-dots custom-dots">
                            {updates.map((update, index) => {
                                return (
                                    <Box key={index} sx={{ px: 1 }}>
                                        <Box
                                            sx={{
                                                textAlign: 'center',
                                                p: 3,
                                                minHeight: 280,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                            }}>
                                            {/* Feature Icon */}
                                            <Box
                                                sx={{
                                                    width: 60,
                                                    height: 60,
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    mx: 'auto',
                                                    mb: 3,
                                                }}
                                            >
                                                <Typography
                                                    level="h1"
                                                    component="div"
                                                    sx={{ color: update.color }}>
                                                    {update.image}
                                                </Typography>
                                            </Box>

                                            {/* Title */}
                                            <Typography
                                                level="h4"
                                                sx={{
                                                    color: '#1e293b',
                                                    fontWeight: 600,
                                                    mb: 2,
                                                }}>
                                                {update.title}
                                            </Typography>

                                            {/* Subtitle */}
                                            <Typography
                                                level="body-sm"
                                                sx={{
                                                    color: '#64748b',
                                                    lineHeight: 1.6,
                                                    maxWidth: 420,
                                                    mx: 'auto',
                                                }}>
                                                {update.subtitle}
                                            </Typography>
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Slider>
                    </Box>
                </Box>

                {/* Action button */}
                <Box sx={{
                    p: 3,
                    borderTop: '1px solid',
                    borderTopColor: 'neutral.100',
                    textAlign: 'center',
                }}>
                    <Button
                        variant="solid"
                        color="primary"
                        sx={{
                            fontWeight: 600,
                            borderRadius: 8,
                            px: 4,
                            py: 1,
                        }}
                        onClick={() => setOpen(false)}>
                        Close
                    </Button>
                </Box>
            </ModalDialog>
        </Modal >
    );
}